import React from "react";

const TransferTable = ({ reportData, totalcount, handlePrint, data }) => {
  return (
    <div className="filter cm-content-box box-primary">
      <div className="content-title d-flex justify-content-between align-items-center">
        <div className="cpa">
          <i className="fa fa-list me-2"></i>Transfer Voucher Items
          <span className="badge bg-orange ms-2">{totalcount}</span>
        </div>
        <div className="d-flex align-items-center">
          {reportData.length > 0 && (
            <button className="btn btn-primary me-3" onClick={() => handlePrint("MTN")}>
            Print
          </button>
          )}
        </div>
      </div>
      <div className="cm-content-body form excerpt">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Store From</th>
                  <th>Store To</th>
                  <th>Date</th>
                  <th>MRV No</th>
                  <th>Part No</th>
                  <th>Description</th>
                  <th>Unit</th>
                  <th>Transfer Qty</th>
                  <th>Approved Qty</th>
                  <th>Received Qty</th>
                  <th>Status</th>
                  <th>Store Keeper</th>
                  <th>Updated Date</th>
                
                </tr>
              </thead>
              <tbody>
                {reportData.length > 0 ? (
                  reportData.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item?.from || "N/A"}</td>
                      <td>{item?.to || "N/A"}</td>
                      <td>{item?.createdAt?.split("T")[0] || "N/A"}</td>
                      <td>{data?.document?.mrvNo || "N/A"}</td>
                      <td>{item?.masterItem?.partNo || "N/A"}</td>
                      <td className="scrollable-description">{item?.masterItem?.description || "N/A"}</td>
                      <td>{item?.masterItem?.unitName || "N/A"}</td>
                      <td>{item?.transferQty || "N/A"}</td>
                      <td>{item?.approveQty || "N/A"}</td>
                      <td>{item?.recived || "N/A"}</td>
                      <td>{item?.status || "N/A"}</td>
                      <td>{data?.document?.user?.name || "N/A"}</td>
                      <td>{item?.updatedAt?.split("T")[0] || "N/A"}</td>
                    
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="14" className="text-center">
                      No data available.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(TransferTable);
